import { differenceInHours, differenceInMinutes, differenceInSeconds } from 'date-fns'
import { useCallback, useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Link, useNavigate } from 'react-router-dom'
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/react'
import { SectionDetailType } from '../../@types/home'
import { getSectionsDetail, getSectionsDetailSoldout } from '../../api/home'
import { postLikeProducts } from '../../api/product'
import { BtnHomeModuleMore } from '../../components/Button'
import ProductCenterModal from '../../components/product/ProductCenterModal'
import { BtnCart } from '../../components/product/ProductItem'
import ProductModal from '../../components/product/ProductModal'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { useMyContext } from '../../components/provider/MyProvider'
import { useAppContext } from '../../components/provider/AppProvider'
import { IconStarOn } from '../../components/svg/IconSvg'
import { AFWebLinkType, handlePostMessage, RNPostMessage } from '../../js/postMessage'
import { findObjectsWithValue, formatNumberWithTruncation, onErrorImg, plusComma } from '../../js/script'
import { imgURL } from '../Home'

const HotDeal = ({ el, category }: any) => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  })
  const [sectionItem, setSectionItem] = useState<SectionDetailType>()
  const [isModal, setIsModal] = useState<boolean>(false)
  const [selectProductNo, setSelectProductNo] = useState<string>()
  const [like, setLike] = useState<boolean>(false)
  const navigate = useNavigate()
  const [time, setTime] = useState<string>('')

  const { isAppView } = useAppContext()

  useEffect(() => {
    getSectionsDetail(el.sectionNo)
      .then((res) => {
        res.data.map((el: any) => {
          setSectionItem(el)
        })
      })
      .catch((err) => console.log(err))
  }, [like])

  const calculateTimeLeft = useCallback(() => {
    const targetTime = new Date(time)
    const now = new Date()

    // 남은 시간이 있는지 확인
    if (targetTime > now) {
      // 시, 분, 초 계산
      const hours = differenceInHours(targetTime, now)
      const minutes = differenceInMinutes(targetTime, now) % 60
      const seconds = differenceInSeconds(targetTime, now) % 60

      // 시간 상태 업데이트
      setTimeLeft({
        hours,
        minutes,
        seconds,
      })
    } else {
      // 시간이 다 지난 경우
      setTimeLeft({
        hours: 0,
        minutes: 0,
        seconds: 0,
      })
    }
  }, [time])

  useEffect(() => {
    if (time) {
      calculateTimeLeft()
      const intervalId = setInterval(calculateTimeLeft, 1000)
      return () => clearInterval(intervalId)
    }
  }, [calculateTimeLeft, time])

  const formatTwoDigits = (num: number) => {
    return num.toString().padStart(2, '0')
  }

  useEffect(() => {
    getSectionsDetailSoldout(el.sectionNo)
      .then((res) => {
        const sectionItems = res.data.map((item: any) => item)
        setSectionItem(sectionItems) // 한 번에 업데이트
        // setHotdealCount(sectionItems.reduce((count, item) => count + item.products.length, 0));
      })
      .catch((err) => console.log(err))
  }, [like])

  useEffect(() => {
    if (sectionItem?.products?.length !== 0) {
      sectionItem?.products?.map((el: any, idx: number) => {
        if (idx === 0) {
          setTime(el.sectionProductEndYmdt)
        }
      })
    }
  }, [sectionItem])

  return (
    <div className='hot_deal'>
      <div className='hot_deal_title'>
        {el.showRemainingTime && (
          <div className='time'>
            {` ${formatTwoDigits(timeLeft.hours)}:${formatTwoDigits(timeLeft.minutes)}:${formatTwoDigits(
              timeLeft.seconds
            )}`}{' '}
            <span>남음</span>
          </div>
        )}
      </div>
      <Swiper
        spaceBetween={8}
        slidesPerView={1.21957}
        breakpoints={{
          768: {
            spaceBetween: 16,
            slidesPerView: 4,
          },
        }}
      >
        {sectionItem?.products?.map((element: any, idx: number) => {
          return (
            <SwiperSlide key={idx}>
              <HotdealItem
                el={element}
                setIsModal={setIsModal}
                setSelectProductNo={setSelectProductNo}
                key={element.productNo}
                setLike={setLike}
                like={like}
                category={category}
                listId={el.sectionNo}
                listName={el.sectionName}
                idx={idx}
              ></HotdealItem>
            </SwiperSlide>
          )
        })}
      </Swiper>
      {el.hasMoreButton ? (
        <div className='btn_more_wrap'>
          <BtnHomeModuleMore
            onClick={() => {
              if (isAppView) {
                RNPostMessage(AFWebLinkType.moveToLink, {
                  url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/exhibitiondetail/39711`,
                })
              } else {
                navigate('/exhibitiondetail/39711')
              }
            }}
          >
            더보기
          </BtnHomeModuleMore>
        </div>
      ) : null}
      {/* {idx + 1 === homeModule.length || idx === 0 ? null : <hr />} */}
      {isModal ? (
        isMobile ? (
          <ProductModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={sectionItem?.products}
          ></ProductModal>
        ) : (
          <ProductCenterModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={sectionItem?.products}
          ></ProductCenterModal>
        )
      ) : null}
    </div>
  )
}

export default HotDeal

function HotdealItem({
  el,
  setSelectProductNo,
  setIsModal,
  setLike,
  like,
  accumulateRate,
  listId,
  listName,
  category,
  idx,
}: any) {
  const { isAppView } = useAppContext()
  const { setIsLogin, hasAccessToken } = useCommonContext()
  const { setToastMessage, setToastBtnMessage, setToastEvent, setIsToast } = useMyContext()

  const [wish, setWish] = useState(false)
  const [disCountAcc, setDisCountAcc] = useState(0)
  const [image, setImage] = useState<any>([])
  const [text, setText] = useState<any>([])
  const [categoryNo, setCategoryNo] = useState<any>([])
  const [itemCategory, setItemCategory] = useState<any>([])
  const [categorys, setCategorys] = useState<any>([])

  const navigate = useNavigate()

  useEffect(() => {
    setImage([])
    setText([])
  }, [el])

  useEffect(() => {
    if (el) {
      el.stickerInfos?.map((element: any) => {
        if (element.type === 'IMAGE') {
          setImage((prev: any) => [...prev, element])
        } else {
          if (text.length === 0) {
            setText((prev: any) => [...prev, element])
          }
        }
      })
    }
  }, [el])

  useEffect(() => {
    if (el) {
      const count = formatNumberWithTruncation((el?.salePrice - el?.immediateDiscountAmt) * 0.1)
      setDisCountAcc(Number(count.replaceAll(',', '')))
    }
  }, [el])
  useEffect(() => {
    setWish(el.liked)
  }, [])

  useEffect(() => {
    setCategoryNo(el.displayCategoryNos.split('|'))
  }, [el])

  useEffect(() => {
    if (categoryNo && category) {
      categoryNo.map((el: any) => {
        setItemCategory((prev: any) => [...prev, ...findObjectsWithValue(category?.flatCategories, Number(el))])
      })
    }
  }, [categoryNo, category])

  useEffect(() => {
    if (itemCategory) {
      itemCategory.map((el: any) => {
        if (el.depth1Label !== '브랜드') {
          setCategorys((prev: any) => [...prev, el])
        }
      })
    }
  }, [itemCategory])

  return (
    <div className='item_wrap' key={el.productNo}>
      <div className='item_img'>
        {el.isSoldOut ? (
          <div className='soldout'>
            <img src={`${imgURL}/img_soldout.png`} alt='' />
          </div>
        ) : null}
        <button
          onClick={() => {
            if (hasAccessToken) {
              let likeItem = { like: '', productNo: '' }

              if (wish) {
                likeItem = { like: 'N', productNo: el.productNo }
              } else {
                likeItem = { like: 'Y', productNo: el.productNo }
              }

              postLikeProducts(likeItem)
                .then((res: any) => {
                  if (res.data.length !== 0) {
                    setWish((prev: boolean) => !prev)
                    if (res.data[0].like === 'Y') {
                      setIsToast(true)
                      setToastMessage('찜 리스트에 저장되었습니다.')
                      setToastBtnMessage('바로가기')
                      setToastEvent(() => () => {
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/wishList`,
                          })
                        } else {
                          navigate('/wishList')
                        }
                      })
                    } else if (res.data[0].like === 'N') {
                      setIsToast(true)
                      setToastMessage('찜 리스트에 제외되었습니다.')
                      setToastBtnMessage('바로가기')
                      setToastEvent(() => () => {
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/wishList`,
                          })
                        } else {
                          navigate('/wishList')
                        }
                      })
                    }
                    setTimeout(() => {
                      setLike((prev: boolean) => !prev)
                    }, 200)
                  }
                })
                .catch((err) => console.log(err))
            } else {
              setIsToast(true)
              setToastMessage('로그인이 필요한 서비스입니다.')
              setToastBtnMessage('로그인')
              setToastEvent(() => () => setIsLogin(true))
              if (isAppView) {
                // onSignInInducement();
                handlePostMessage({ actionType: 'onSignInInducement' })
              }
            }

            // setWish((prev) => !prev);
          }}
        >
          <img
            src={`${wish ? `${imgURL}/icon_heart_fill.png` : `${imgURL}/icon_heart_outline.png`}`}
            alt='찜하기 아이콘'
          />
        </button>
        {/* <LikeBtn
          wish={wish}
          item={el}
          setWish={setWish}
          setSubmitWish={setLike}
        ></LikeBtn> */}

        {image.map((element: any, index: number) => {
          return (
            <div className='item_flag' key={index}>
              <img src={element.label} alt='' />
            </div>
          )
        })}
        <Link
          to={`/product/${el.productNo}`}
          onClick={(e) => {
            e.preventDefault()
            const array: any = []
            // setPrevScroll(document.documentElement.scrollTop);
            if (isAppView) {
              RNPostMessage(AFWebLinkType.moveToLink, {
                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${el.productNo}`,
              })
            } else {
              navigate(`/product/${el?.productNo}`)
            }
          }}
        >
          <div className='dim'></div>
          <img src={`${el?.imageUrls[0]}`} alt='' onError={onErrorImg} />
        </Link>
      </div>

      <BtnCart
        style={{
          width: '100%',
        }}
        onClick={() => {
          setSelectProductNo(el.productNo)
          setIsModal(true)
        }}
      >
        <img src={`${imgURL}/icon_cart.png`} alt='' />
        {el?.isSoldOut ? '재입고 알림' : '장바구니'}
      </BtnCart>
      <Link
        to={`/product/${el.productNo}`}
        onClick={(e) => {
          e.preventDefault()
          // setPrevScroll(document.documentElement.scrollTop);
          if (isAppView) {
            RNPostMessage(AFWebLinkType.moveToLink, {
              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${el.productNo}`,
            })
          } else {
            navigate(`/product/${el?.productNo}`)
          }
        }}
      >
        {el?.brandName && <div className='item_brand_title'>{el?.brandName}</div>}
        <div className='item_title'>{el?.productName}</div>

        {Math.floor((el?.immediateDiscountAmt / el?.salePrice) * 100) === 0 ? (
          <div className='item_sale_wrap'>
            <p className='price'>{plusComma(el?.salePrice - el?.immediateDiscountAmt)}원</p>
          </div>
        ) : (
          <>
            <div className='item_origin_price'>{plusComma(el?.salePrice)}원</div>

            <div className='item_sale_wrap'>
              <p className='percent'>{Math.floor((el?.immediateDiscountAmt / el?.salePrice) * 100)}%</p>
              <p className='price'>{plusComma(el?.salePrice - el?.immediateDiscountAmt)}원</p>
            </div>
          </>
        )}

        {!el?.accumulationUseInfo?.usable && !el.enableCoupons ? null : el?.salePrice -
            el?.immediateDiscountAmt -
            el?.couponDiscountAmt -
            (el?.accumulationInfo.rewardRateOfProduct !== 0 ? el?.accumulationInfo?.amount : 0) -
            (el?.accumulationUseInfo?.usable ? Number(disCountAcc) : 0) ===
          Number(el?.salePrice - el?.immediateDiscountAmt) ? null : (
          <div className='item_maximum_benefit'>
            <p className='badge'>회원혜택가</p>
            <div>
              <p>
                {plusComma(
                  el?.salePrice -
                    el?.immediateDiscountAmt -
                    el?.couponDiscountAmt -
                    (el?.accumulationInfo.rewardRateOfProduct !== 0 ? el?.accumulationInfo?.amount : 0) -
                    (el?.accumulationUseInfo?.usable ? Number(disCountAcc) : 0) <
                    0
                    ? 0
                    : el?.salePrice -
                        el?.immediateDiscountAmt -
                        el?.couponDiscountAmt -
                        (el?.accumulationInfo.rewardRateOfProduct !== 0 ? el?.accumulationInfo?.amount : 0) -
                        (el?.accumulationUseInfo?.usable ? Number(disCountAcc) : 0)
                )}
                원
              </p>
            </div>
          </div>
        )}

        {/* 페이백 적립금 5% + 추가적립금 */}
        {hasAccessToken && el?.accumulationInfo?.amount > 0 ? (
          <>
            <div className='save_mileage'>
              <span>
                {`페이백 적립금 ${el?.accumulationInfo.rewardRateOfProduct}% `}
                {plusComma(el?.accumulationInfo?.amount)}
                <img src={`${imgURL}/icon_point.png`} alt='' />
              </span>
            </div>
          </>
        ) : null}

        {/* 별점 */}
        <div className='item_star_rating'>
          <IconStarOn width={isMobile ? 14 : 16} height={isMobile ? 14 : 16} />
          <span className='review_rating'>{el?.reviewRating}</span>
          <span className='review_num'>({el?.totalReviewCount})</span>

          {/* Npay */}
          <div className='npay'>
            <img src={`${imgURL}/icon_npay.png`} alt='Naver Pay' />
          </div>
        </div>

        {/* flag 없으면 보이지 않게 함 */}
        {text.length !== 0 && (
          <div className='item_txt_flag'>
            {text.map((el: any, idx: number) => {
              return (
                <span className='delivery' key={idx}>
                  {el.label}
                </span>
              )
            })}
          </div>
        )}
      </Link>
    </div>
  )
}
